import React, { memo } from 'react';
import ResultTableRow from './ResultTableRow';

/**
 * テーブルヘッダー定義
 * key はReactのkey属性、label はヘッダーテキスト、className は列幅制御用クラス
 */
const HEADERS = [
  { key: 'no',           label: 'No.',       className: 'dc-th--no' },
  { key: 'type',         label: '生保/損保', className: 'dc-th--type' },
  { key: 'docType',      label: '文書種別',  className: 'dc-th--doc-type' },
  { key: 'company',      label: '保険会社',  className: 'dc-th--min' },
  { key: 'category',     label: '商品種別',  className: 'dc-th--wide' },
  { key: 'docName',      label: '商品名',    className: 'dc-th--wide' },
  { key: 'remarks',      label: '備考',      className: 'dc-th--wide' },
  { key: 'additionalInfo', label: '詳細情報', className: 'dc-th--wide' },
  { key: 'applicableDate',    label: '文書適用日', className: 'dc-th--date' },
  { key: 'action',       label: '詳細',          className: 'dc-th--action' },
];

/**
 * 搭載文書検索結果テーブルコンポーネント
 *
 * HEADERS 定義に基づいてヘッダー行を生成し、
 * items を ResultTableRow にマップして tbody を構成する。
 * テーブル全体を .dc-table-wrapper でラップして横スクロールに対応する。
 *
 * @param {Object} props
 * @param {Array} props.items - 表示する DocumentCatalogItem の配列
 * @param {Function} props.onNavigate - 詳細遷移コールバック（ResultTableRow に渡す）
 */
const ResultsTable = ({ items, onNavigate }) => (
  <div style={{ overflowX: 'auto' }}>
    <table className="applications-table dc-table">
      <thead>
        <tr>
          {HEADERS.map((h) => (
            <th key={h.key} className={h.className || undefined}>
              {h.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <ResultTableRow key={item.id} item={item} onNavigate={onNavigate} />
        ))}
      </tbody>
    </table>
  </div>
);

export default memo(ResultsTable);
